import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@/core/localization';
import { QuantityChipRevokable } from '../shared.styled';
const BlockedQuantityChip = ({ blockedQuantity, onDelete, onDoubleClick }) => {
    const handleDoubleClick = (event) => {
        // Prevents *row* double click event.
        event.stopPropagation();
    };
    return (_jsx(QuantityChipRevokable, { size: "medium", variant: "outlined", color: "error", label: blockedQuantity, title: `${t('cancel.blocking.label')} (+)`, tabIndex: -1, onDelete: onDelete, onDoubleClick: onDoubleClick ?? handleDoubleClick }));
};
export { BlockedQuantityChip };
